import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import Upload, { RcFile } from "antd/lib/upload"
import styles from "../filing.module.css"
import axios from "axios"
import { PreviewImgOrPdf } from "../Preview"
import { AXIOS_IP, beforeUploadFile, beforeUploadFileAndImage, customRequest, downloadFile } from "../fileUploadService"
import { selectCredentials } from "../../../app/applicationSlice"
import { DateTimeFormatSimpleOnly } from "../../../models/datetime"
import moment from "moment"

export const WCTJFormModal = (props: {
  visible: boolean
  token: string
  id?: number
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const credentials: any = useSelector(selectCredentials)
  
  const [form] = Form.useForm()

  const { TextArea } = Input

  const { RangePicker } = DatePicker

  const [fileWCList, setFileWCList] = useState<any>([]) //外出健康
  const [fileTJList, setFileTJList] = useState<any>([]) //体检情况
  const [fileSMList, setFileSMList] = useState<any>([]) //书面说明
  const [fileFWList, setFileFWList] = useState<any>([]) //医疗废物
  const [fileZYList, setFileZYList] = useState<any>([]) //执业许可证

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [submitVisible, setSubmitVisible] = useState(false)

  //健康参考模板
  const templateJKData = {
    fileConfigId: "5",
    fileName: "健康体检协议书参考模板",
    fileType: "application/msword",
    filePath:
      "9d8a1b8c3709ab2ed02669a539c45ac397057af0b1254dfa05f69095748bdca4.doc",
  }

  //体检参考模板
  const templateTJData = {
    fileConfigId: "5",
    fileName: "体检相关书面说明参考模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath:
      "df1516f7ca7d4134498e1a67fc18065d8e3d800a595f76a109657d2b52b9e2b7.docx",
  }

  //医疗废物参考模板
  const templateYLData = {
    fileConfigId: "5",
    fileName: "医疗废物处理方案参考模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath:
      "df1516f7ca7d4134498e1a67fc18065d8e3d800a595f76a109657d2b52b9e2b7.docx",
  }

  // 自定义上传实现
    const customRequestFn = (options: any, type: string) => {
      customRequest(options, AXIOS_IP, (data: any) => {
        const newurl = {
          fileConfigId: data?.configId,
          fileName: data?.name,
          fileType: data?.type,
          filePath: data?.path,
        }
        switch (type) {
          case "WC":
            setFileWCList([...fileWCList, newurl])
            break
          case "TJ":
            setFileTJList([...fileTJList, newurl])
            break
          case "SM":
            setFileSMList([...fileSMList, newurl])
            break
          case "FW":
            setFileFWList([...fileFWList, newurl])
            break
          case "ZY":
            setFileZYList([...fileZYList, newurl])
            break
        }
      })
    }
  
    const handleRemove = (type: string, index: number) => {
      switch (type) {
        case "WC":
          setFileWCList(fileWCList?.filter((v: any, i: number) => i !== index))
          break
        case "TJ":
          setFileTJList(fileTJList?.filter((v: any, i: number) => i !== index))
          break
        case "SM":
          setFileSMList(fileSMList?.filter((v: any, i: number) => i !== index))
          break
        case "FW":
          setFileFWList(fileFWList?.filter((v: any, i: number) => i !== index))
          break
        case "ZY":
          setFileZYList(fileZYList?.filter((v: any, i: number) => i !== index))
          break
      }
    }
  
  const getData = () => {
      axios({
        url: `${AXIOS_IP}/filingReviewOutCheckup/detail`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": props.token,
        },
        withCredentials: false,
        method: "POST",
        data: { id: props.id },
      }).then((res) => {
        const data = res.data.data
        form.setFieldsValue({
          ...data,
          time: [
            moment(data?.startTime),
            moment(data?.endTime)
          ]
        })
        setFileWCList(data?.outDescriptionFileUrl || [])
        setFileTJList(data?.checkupDealFileUrl || [])
        setFileSMList(data?.checkupAboutFileUrl || [])
        setFileFWList(data?.medicalWasteFileUrl || [])
        setFileZYList(data?.orgPracticeFileUrl || [])
    })
  }
  

  useEffect(() => {
    form.setFieldsValue({
      outDescriptionFileUrl: fileWCList,
    })
  }, [fileWCList])

  useEffect(() => {
    form.setFieldsValue({
      checkupDealFileUrl: fileTJList,
    })
  }, [fileTJList])

  useEffect(() => {
    form.setFieldsValue({
      checkupAboutFileUrl: fileSMList,
    })
  }, [fileSMList])

  useEffect(() => {
    form.setFieldsValue({
      medicalWasteFileUrl: fileFWList,
    })
  }, [fileFWList])

  useEffect(() => {
    form.setFieldsValue({
      orgPracticeFileUrl: fileZYList,
    })
  }, [fileZYList])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setFileWCList([])
      setFileTJList([])
      setFileSMList([])
      setFileFWList([])
      setFileZYList([])
    } else {
      if(props.id) {
        getData()
      }
    }
  }, [props.visible, props.id])
  return (
    <>
      <Modal
        title="外出体检备案"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
            style={{ paddingRight: 10 }}
            initialValues={{
              isClient: 1
            }}
            onFinish={(vs) => {
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="time"
                  label="外出时间"
                  rules={[{ required: true }]}
                >
                  <RangePicker
                    format={DateTimeFormatSimpleOnly}
                    style={{ width: "50%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="location"
                  label="地点"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="content"
                  label="内容"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={100} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="外出健康体检情况说明"
                  name="outDescriptionFileUrl"
                  rules={[{ required: true, message: "请上传外出健康体检情况说明" }]}
                >
                  <div>
                    <div style={{ padding: "5px 0px 10px 0px" }}>
                      包括邀请单位的基本情况、受检者数量、地址和基本情况、体检现场基本情况等，文件格式为加盖公章的pdf和图片上传。
                      <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => downloadFile(templateJKData, props.token, 'doc')}  
                      >
                        参考模板
                      </a>
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "WC")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileWCList)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileWCList?.length > 0 &&
                        fileWCList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{ paddingRight: 10 }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("WC", index)
                              }}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="健康体检协议书"
                  name="checkupDealFileUrl"
                  rules={[{ required: true, message: "请上传健康体检协议书" }]}
                >
                  <div>
                    <div style={{ padding: "5px 0px 10px 0px" }}>
                      双方签订的健康体检协议书，文件格式为pdf扫描件和图片上传。
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "TJ")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileTJList)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileTJList?.length > 0 &&
                        fileTJList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{ paddingRight: 10 }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("TJ", index)
                              }}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="体检相关书面说明"
                  name="checkupAboutFileUrl"
                  rules={[{ required: true, message: "请上传体检相关书面说明" }]}
                >
                  <div>
                    <div style={{ padding: "5px 0px 10px 0px" }}>
                      体检现场标本采集、运送等符合有关条件和要求的书面说明，文件格式为加盖公章的pdf和图片上传。
                      <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => downloadFile(templateTJData, props.token, 'docx')}  
                      >
                        参考模板
                      </a>
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "SM")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileSMList)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileSMList?.length > 0 &&
                        fileSMList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{ paddingRight: 10 }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("SM", index)
                              }}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="医疗废物处理方案"
                  name="medicalWasteFileUrl"
                  rules={[{ required: true }]}
                >
                  <div>
                    <div style={{ padding: "5px 0px 10px 0px" }}>
                      现场清洁、消毒和检后医疗废物处理方案，文件格式为加盖公章的pdf和图片上传。
                      <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => downloadFile(templateYLData, props.token, 'docx')}
                      >
                        参考模板
                      </a>
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "FW")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileFWList)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileFWList?.length > 0 &&
                        fileFWList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{ paddingRight: 10 }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("FW", index)
                              }}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="医疗机构执业许可证"
                  name="orgPracticeFileUrl"
                  rules={[{ required: true, message: "请上传医疗机构执业许可证" }]}
                >
                  <div>
                    <div style={{ padding: "5px 0px 10px 0px" }}>
                      医疗机构执业许可证副本复印件，文件格式为pdf扫描件和图片上传。
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "ZY")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileZYList)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileZYList?.length > 0 &&
                        fileZYList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{ paddingRight: 10 }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("ZY", index)
                              }}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            ...form.getFieldsValue(),
            applicantId: credentials.userId,
            applicantName: credentials.userName,
            id: props.id,
            memo: props.memo,
            StartTime: form.getFieldValue("time")
              ? form.getFieldValue("time")[0].format("YYYY-MM-DD")
              : null,
            EndTime: form.getFieldValue("time")
              ? form.getFieldValue("time")[1].format("YYYY-MM-DD")
              : null,
            time: undefined
          }
          axios({
            url: `${AXIOS_IP}/filingReviewOutCheckup/createOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then(() => {
              setSubmitVisible(false)
              notification.success({
                message: "操作成功",
              })
              props.onOk()
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
